import { Reveal } from "@/components/Reveal";
import { ArrowUpRight } from "lucide-react";

const services = [
  { n: "01", title: "Brand Identity", desc: "Logos, typography systems and visual worlds built around your sound." },
  { n: "02", title: "Art Direction", desc: "Cover art, photo direction and campaign imagery with a singular point of view." },
  { n: "03", title: "Rollout Strategy", desc: "Single, EP and album launches choreographed like a three-act play." },
  { n: "04", title: "Social & Content", desc: "Feeds that feel like a universe, not a content calendar." },
  { n: "05", title: "Merch & Packaging", desc: "Vinyl, tees and objects fans frame instead of fold." },
  { n: "06", title: "Web Experience", desc: "Sites and micro-experiences that win awards and sell tickets." },
];

export const Services = () => (
  <section id="services" data-testid="services-section" className="py-28 md:py-44 bg-[#FDFBF7]">
    <div className="max-w-[1400px] mx-auto px-6 md:px-12">
      <Reveal className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16 md:mb-24">
        <div>
          <p className="text-[11px] font-semibold uppercase tracking-[0.35em] text-[#2D1A13]/50 mb-6">The Menu</p>
          <h2 className="font-serif-display font-bold tracking-tighter text-4xl md:text-6xl leading-tight">
            Pick your <span className="italic text-[#DDA77B]">scoops.</span>
          </h2>
        </div>
        <p className="max-w-sm text-sm font-light leading-relaxed text-[#2D1A13]/60">
          Full rebrand or a single flavour — every engagement is scoped around what the release actually needs.
        </p>
      </Reveal>

      <div data-testid="services-list" className="border-b border-[#2D1A13]/15">
        {services.map((s, i) => (
          <Reveal key={s.n} delay={i * 0.04} y={20}>
            <div
              data-testid={`service-row-${s.n}`}
              className="group relative border-t border-[#2D1A13]/15 overflow-hidden cursor-default"
            >
              <div className="absolute inset-0 bg-[#FF8E9E] scale-y-0 group-hover:scale-y-100 origin-bottom transition-transform duration-500 ease-[cubic-bezier(0.22,1,0.36,1)]" />
              <div className="relative grid md:grid-cols-12 items-center gap-2 md:gap-6 px-2 md:px-6 py-8 md:py-10">
                <span className="font-serif-display italic text-lg text-[#2D1A13]/40 md:col-span-1">{s.n}</span>
                <h3 className="font-serif-display font-bold text-3xl md:text-5xl tracking-tight md:col-span-6 group-hover:translate-x-3 transition-transform duration-500">
                  {s.title}
                </h3>
                <p className="text-sm font-light text-[#2D1A13]/65 md:col-span-4 max-w-sm">{s.desc}</p>
                <span className="hidden md:flex md:col-span-1 justify-end">
                  <ArrowUpRight
                    size={28}
                    strokeWidth={1.5}
                    className="opacity-0 -translate-x-2 translate-y-2 group-hover:opacity-100 group-hover:translate-x-0 group-hover:translate-y-0 transition-all duration-500"
                  />
                </span>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
